import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpInterceptorService } from './shared/services/http-interceptor.service';
import { HomeModule } from './modules/home/home.module';
import { AdminModule } from './modules/admin/admin.module';
import { SharedModule } from './shared/shared.module';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { AuthModule } from './modules/auth/auth.module';
import { DataModule } from './data/data.module';
import { CoreModule } from './core/core.module';
import { DecimalPipe, HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { JwtModule } from "@auth0/angular-jwt";
import { HttpInterceptorProviders } from '@modules/home/landing-page/interceptors/interceptor-provider';
import { Amplify } from 'aws-amplify';
import { environment } from '@environments/environment';
import { NgIdleModule } from '@ng-idle/core';

// For Siteminder
Amplify.configure(environment.config);

// For dev octa

// Amplify.configure({
//   "aws_project_region": "us-west-2",
//   "aws_cognito_region": "us-west-2",
//   "aws_user_pools_id": "us-west-2_P95qc4BsP",
//   "aws_user_pools_web_client_id": "4h5b84mm5jfcaf6gd5817ch38o",
//   "oauth": {
//       "domain": "mpg-domain-dev.auth.us-west-2.amazoncognito.com",
//       "scope": [
//           "email",
//           "openid",
//           "profile",
//           "aws.cognito.signin.user.admin"
//       ],
//       "redirectSignIn": "https://mpgpsr-dev.spe.sony.com",
//       "redirectSignOut": "https://mpgpsr-dev.spe.sony.com/",
//       "responseType": "code"
//   }
// });

@NgModule({
  declarations: [
    AppComponent,
    ContentLayoutComponent,
    HeaderComponent,
    FooterComponent,
    AuthLayoutComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    DataModule,
    CoreModule,
    SharedModule,
    AuthModule,
    AdminModule,
    HomeModule,
    JwtModule,
    BrowserAnimationsModule,
    NgIdleModule.forRoot()
  ],
  providers: [
    { 
      provide: HTTP_INTERCEPTORS, 
      useClass: HttpInterceptorService, 
      multi: true
    }, 
    {
      provide: LocationStrategy, 
      useClass: PathLocationStrategy
    },
    DecimalPipe,
    HttpInterceptorProviders,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
